/* Giuseppis 2.0 — interacciones ligeras (sin dependencias) */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Menú móvil */
  var drawer = $('[data-g2-drawer]');
  function closeDrawer() { if (drawer) drawer.classList.remove('is-open'); document.body.style.overflow = ''; }
  $$('[data-g2-drawer-open]').forEach(function (b) { b.addEventListener('click', function () { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; }); });
  $$('[data-g2-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* Contador del carrito */
  function setCount(n) { $$('[data-g2-cart-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-count', n); }); }
  fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); }).catch(function () {});

  /* Aviso flotante */
  var toast = $('[data-g2-toast]'), toastTimer;
  function showToast(html) {
    if (!toast) return;
    toast.innerHTML = html; toast.classList.add('is-visible');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, 5000);
  }

  /* Agregar al carrito sin salir de la página */
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f.matches || !f.matches('[data-g2-atc]')) return;
    e.preventDefault();
    var btn = f.querySelector('[type=submit]'); var label = btn.innerHTML;
    btn.classList.add('is-loading'); btn.textContent = 'Agregando…';
    fetch('/cart/add.js', { method: 'POST', body: new FormData(f), headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function (item) {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
          setCount(c.item_count);
          showToast('<span>' + (item.product_title || 'Producto') + ' agregado al carrito</span><a href="/cart">Ver carrito →</a>');
          btn.textContent = 'Agregado ✓';
          setTimeout(function () { btn.innerHTML = label; btn.classList.remove('is-loading'); }, 1800);
          document.dispatchEvent(new CustomEvent('cart:update', { detail: c }));
        });
      })
      .catch(function () { btn.classList.remove('is-loading'); btn.innerHTML = label; f.submit(); });
  });

  /* Cantidad */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-g2-qty]'); if (!b) return;
    var inp = b.parentElement.querySelector('input'); var v = parseInt(inp.value || '1', 10) || 1;
    v += b.getAttribute('data-g2-qty') === '+' ? 1 : -1; inp.value = Math.max(1, v);
    inp.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Galería */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-g2-thumb]'); if (!b) return;
    var main = $('[data-g2-main-img]');
    if (main) { main.removeAttribute('srcset'); main.src = b.getAttribute('data-g2-thumb'); }
    $$('[data-g2-thumb]').forEach(function (x) { x.removeAttribute('aria-current'); });
    b.setAttribute('aria-current', 'true');
  });

  /* Barra fija de compra en móvil */
  var sticky = $('[data-g2-sticky]'), buy = $('[data-g2-buy]');
  if (sticky && buy && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(buy);
    var sb = $('[data-g2-sticky-submit]');
    if (sb) sb.addEventListener('click', function () { var f = $('[data-g2-atc-main]'); if (f) { f.requestSubmit ? f.requestSubmit() : f.querySelector('[type=submit]').click(); } });
  }
})();
